import React from "react";
import UpSellWidgetCustomParent from "../components/UpSellWidgetCustomParent";
import useFreeInsightsPopupModel from "../hooks/useFreeInsightsPopupModel";
import { UpsellWidgetModelProvider } from "../hooks/useUpsellWidgetModelContext";
import { useStickyUpsellPanelContext } from "../../stickyUpsellPanel/useStickyUpsellPanelContext";

export const UpsellPopupFreeInsights = () => {
    const { downloadFileId, setShowUpsell } = useStickyUpsellPanelContext();

    const model = useFreeInsightsPopupModel(downloadFileId);
    
    return (
        <UpsellWidgetModelProvider model={model}>
            <UpSellWidgetCustomParent setShowUpsell={setShowUpsell} />
        </UpsellWidgetModelProvider>
    );
};